<template>
  <div class="tabs">
    <div class="tabs__header">
      <ul class="nav--tabs">
        <li v-for="(tab, index) in tabs" :key="index" :class="{'is-active': tab.isActive}">
          <a @click="selectTab(tab)">
            <span>{{ tab.name }}</span>
          </a>
        </li>
      </ul>
    </div>
    <div class="tabs__body">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'tabs',
  data() {
    return {
      tabs: [],
    };
  },
  methods: {
    selectTab(selectedTab) {
      this.tabs.forEach(tab => {
        tab.isActive = tab.name === selectedTab.name;
      });
      window.location.hash = `#${selectedTab.name}`;
    },
    selectTabByName(name) {
      const found = this.tabs.find(tab => tab.name === name);

      if (found) {
        this.tabs.forEach(tab => {
          tab.isActive = tab.name === name;
        });
      }
    },
    selectTabByHash(hash) {
      this.selectTabByName(hash.replace('#', ''));
    },
  },
  created() {
    this.tabs = this.$children;

    if (window.location.hash) {
      setTimeout(() => {
        this.selectTabByHash(window.location.hash);
      }, 1);
    }
  },
};
</script>
